<div class="security-search">
  <div class="col-12 mb-2 mx-1">
    <div class="search-input-wrapper">
      <i class="fa fa-search search-icon"></i>
      <ng-select [items]="securityIndexList" [multiple]="false"
            [typeahead]="securityIndexTypeahead" [loading]="securityIndexSearching"
            bindValue="fsymRegionalId" (change)="securitySelected($event)" name="securityIndex"
            id="securityIndex" placeholder="Search securities by name or ticker"
            [dropdownPosition]="'bottom'"
            #ngCompanySelectComponent>

        <ng-template ng-option-tmp let-item="item">
          <rms-security-index-search-item [item]="item"></rms-security-index-search-item>
        </ng-template>
        <ng-template ng-footer-tmp>
          <div class="manual-public-selection"
               role="button"
               tabindex="0"
               (click)="createManually(ngCompanySelectComponent)"
               (keydown.enter)="createManually(ngCompanySelectComponent)"
               (keydown.space)="createManually(ngCompanySelectComponent)">+ Add {{itemDescription}} Manually</div>
        </ng-template>
      </ng-select>
    </div>
  </div>
</div>

